<section 
  #swiper 
  class="action_buttons swiper"
  [class.fromBottomSheet]="fromBottomSheet()"
>
  <ul class="swiper-wrapper">
    @if (speaker()?.length > 0){
      @if (checkInscription()){
        <li class="swiper-slide">
          <details-button 
            (click)="getQRBooking()" 
            [text]="'Ver mi entrada'" 
            [isSpeakerEntry]="true"
            [isActionButton]="true"
          />
        </li>

      }@else {
        <li class="swiper-slide">
          <details-button 
            (click)="booking()" 
            [text]="'Inscríbete aquí'"
            [isActionButton]="true"
          />
        </li>
      }
    }
    @for (item of actionButtons()?.[translate.currentLang]; track $index){
      <li class="swiper-slide">
        <details-button
            (click)="actionButton(item)" 
            [text]="item.button_text"
            [isActionButton]="true"
          />
      </li> 
    }
    @if (populatedImage360){
      <li class="swiper-slide">
        <details-button 
          (click)="showImage360()" 
          [text]="'Imagen 360'"
          [isActionButton]="true"
        />
      </li>
    }
  </ul>
</section>